import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../shared/services/api/authentication/authentication.service';
import { finalize, first } from 'rxjs/operators';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ForgotPasswordComponent implements OnInit {
  form!: FormGroup;
  loading = false;
  isError = false;
  errorMessage = '';
  submitted = false;
  isEmailSend: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthenticationService
  ) {
    this.isError = false;
    this.isEmailSend = false;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required]],
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;

    // STOP HERE if form is invalid
    if (this.form.invalid) {
      this.isError = true;
      return;
    }

    this.isError = false;
    this.errorMessage = '';
    this.loading = true;

    this.authService
      .forgotPassword(this.f['email'].value.trim())
      .pipe(first())
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          this.isEmailSend = true;
        },
        error: err => {
          this.isError = true;
          this.errorMessage = err?.status === 429 ? 'reset-password.error-too-many-requests' : 'reset-password.no-match';
          this.isEmailSend = false;
        },
      });
  }
}
